import { Badge } from '@datacamp/waffles/badge';
import React from 'react';
import Icon from '../Icon';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Subheading = _ref => {
  let {
    buttonRight,
    children,
    iconColor = null,
    iconName = null,
    iconSize = 18,
    tagContent = null
  } = _ref;
  return ___EmotionJSX("div", {
    className: "dc-u-bgc-grey-400 dc-u-fx dc-u-fx-jcsb dc-u-fx-aic dc-u-bb dc-u-bc-white",
    style: {
      minHeight: '36px'
    }
  }, ___EmotionJSX("h5", {
    className: "dc-u-fx dc-u-fx-aic dc-u-fs-small dc-u-fw-bold dc-u-m-none dc-u-pl-16 dc-u-mr-8 dc-u-t-truncate",
    style: {
      height: '30px',
      lineHeight: '1em'
    }
  }, iconName !== null && ___EmotionJSX(Icon, {
    color: iconColor,
    extraClass: "dc-u-mr-8 dc-u-fxi-fs-0",
    name: iconName,
    size: iconSize
  }), ___EmotionJSX("span", {
    className: "dc-u-t-truncate"
  }, children)), tagContent != null && ___EmotionJSX(Badge, {
    className: "dc-u-mr-8",
    variant: "yellow"
  }, tagContent), buttonRight != null && buttonRight);
};
export default Subheading;